import PropTypes from 'prop-types'
import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import Card from '@/components/Card'
import DeleteConfirmationWithInput from '@/components/DeleteConfirmationWithInput'
import PaginationTable from '@/components/PaginationTable'
import Modal from '@/pages/OrganizationToolbarsPage/AddEditModal'

import columns from './columns'
import messages from './messages'

import './index.scss'

function ToolbarInstances(props: any) {
  const intl = useIntl()

  const [state, _setState] = useState({
    columns: [],
    currentPage: 1,
    showDeleteModal: false,
    showEditModal: false
  })
  const setState = (update: Partial<Parameters<typeof _setState>[0]>) => {
    return _setState(state => ({ ...state, ...(typeof update === 'function' ? update(state) : update) }))
  }

  const onSelect = (page: any) => {
    setState({ currentPage: page })
  }

  const onEditToolbar = (toolbar: any) => {
    props.onSelectToolbar(toolbar)
    setState({
      showEditModal: true
    })
  }

  const onEditCancel = () => {
    props.onClearSelectedToolbar()
    setState({
      showEditModal: false
    })
  }

  const onEditConfirm = (values: any) => {
    props.onEditToolbar(values)
  }

  const onDeleteCancel = () => {
    props.onClearSelectedToolbar()
    setState({
      showDeleteModal: false
    })
  }

  const onDeleteToolbar = (toolbar: any) => {
    props.onSelectToolbar(toolbar)
    setState({
      showDeleteModal: true
    })
  }

  const onDeleteConfirm = () => {
    props.onRemoveToolbar(props.currentToolbar.id)
    setState({
      showDeleteModal: false
    })
  }

  const columnDefinitions = columns({
    intl: intl,
    onEdit: onEditToolbar,
    onDelete: onDeleteToolbar
  })

  const { showDeleteModal, showEditModal } = state
  const { currentToolbar, toolbars } = props

  return (
    <Card className="toolbar-grid">
      {showDeleteModal && (
        <DeleteConfirmationWithInput
          onConfirm={onDeleteConfirm}
          onCancel={onDeleteCancel}
          itemName={'Delete'}
          subMessage={<FormattedMessage {...messages.subMessage} />}
          warning={
            <FormattedMessage
              {...messages.warning}
              values={{ name: <span className="confirm-app-name">{currentToolbar.name}</span> }}
            />
          }
          label={<FormattedMessage {...messages.confirmDelete} />}
          cancel={<FormattedMessage {...messages.cancel} />}
          deleteMessage={<FormattedMessage {...messages.delete} />}
          deleteButton={<FormattedMessage {...messages.deleteButton} />}
        />
      )}

      <Modal
        isEdit={showEditModal}
        onClose={onEditCancel}
        onSubmit={onEditConfirm}
        open={showEditModal}
        formValues={currentToolbar}
      />

      <PaginationTable
        columns={columnDefinitions}
        pagination={{
          isClientPaging: true,
          startIndex: state.currentPage * 10,
          count: toolbars.length,
          perPage: 10
        }}
        onPaginateSelect={onSelect}
        rows={toolbars}
        rowItemType={<FormattedMessage {...messages.toolbarsLowerCase} />}
        rowKey="id"
      />
    </Card>
  )
}

ToolbarInstances.displayName = 'ToolbarInstances'

ToolbarInstances.propTypes = {
  toolbars: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentToolbar: PropTypes.object,
  onRemoveToolbar: PropTypes.func.isRequired,
  onEditToolbar: PropTypes.func.isRequired,
  onSelectToolbar: PropTypes.func.isRequired,
  onClearSelectedToolbar: PropTypes.func.isRequired
}

ToolbarInstances.defaultProps = {}

export default ToolbarInstances
